module.exports = __webpack_public_path__ + "img/unorderedList.c7410ab8.svg";